var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background",style:(_vm.backgroundStyle)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3908f49d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/spa/components/login/layouts/LayoutBackground.vue
// module id = null
// module chunks = 